import Axios from "axios";

import { ReadableUploadSource } from "../../base-types";
import { IUploadSource } from "../../contracts/upload/upload-source";

export class HttpUploadSource implements IUploadSource {
    private static HTTP_SCHEMA = "http";
    private static HTTPS_SCHEMA = "https";

    constructor(
        private uri: URI,
        name: string = ""
    ) {
        if (uri.scheme() !== HttpUploadSource.HTTP_SCHEMA && uri.scheme() !== HttpUploadSource.HTTPS_SCHEMA) {
            throw Error(`'${uri.protocol}' is not a valid upload source.`);
        }

        this.name = name.length > 0 ? name : uri.filename();
    }

    name: string;

    async getReadableSourceAsync(): Promise<ReadableUploadSource> {
        const response = await Axios.get(this.uri.href(), { responseType: "arraybuffer" });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return response.data;
    }
}
